import { render, staticRenderFns } from "./UiTaxRateSelector.vue?vue&type=template&id=5b62e73e&scoped=true"
import script from "./UiTaxRateSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiTaxRateSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b62e73e",
  null
  
)

export default component.exports